import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { collections } from '../../data/collections';
import { images } from '../../data/images';
import { productsForCollection } from '../../utils/products';
import { Reveal } from '../ui/Reveal';
const layout: Record<string, {
  span: string;
  image: string;
  position?: string;
}> = {
  'voor-haar': {
    span: 'col-span-2 aspect-[4/3] lg:row-span-2 lg:aspect-auto',
    image: images.her,
    position: 'object-[50%_30%]'
  },
  'voor-hem': {
    span: 'col-span-1 aspect-[4/5] lg:aspect-auto',
    image: images.him,
    position: 'object-[50%_25%]'
  },
  nieuw: {
    span: 'col-span-1 aspect-[4/5] lg:aspect-auto',
    image: images.cactus
  },
  bestsellers: {
    span: 'col-span-1 aspect-[4/5] lg:aspect-auto',
    image: images.argan
  },
  cadeaus: {
    span: 'col-span-1 aspect-[4/5] lg:aspect-auto',
    image: images.giftset
  }
};
export function ShopTiles() {
  const tiles = collections.filter(c => layout[c.slug]);
  return <section className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-28" data-id="element-127" data-mp="e4anx8hbjlo9">
      <Reveal className="mb-10 flex items-end justify-between gap-6" data-id="element-128" data-mp="e3ho6rgs1wfm">
        <h2 className="max-w-xl font-display text-4xl uppercase tracking-display text-ink sm:text-5xl" data-id="element-129" data-mp="a40ko3kwv9d3">Waar ben je naar op zoek?</h2>
        <Link to="/collectie/alles" className="hidden whitespace-nowrap text-sm font-medium underline underline-offset-4 sm:block" data-id="element-130" data-mp="55p99oeywqsr">
          Alle producten
        </Link>
      </Reveal>

      <ul className="grid grid-cols-2 gap-3 lg:h-[720px] lg:grid-cols-4 lg:grid-rows-2 lg:gap-4" data-id="element-131" data-mp="3rc3zp2grz1vk">
        {tiles.map(c => {
        const t = layout[c.slug];
        return <li key={c.slug} className={t.span} data-id="element-132" data-mp="3ijafcqmh1cau">
              <Link to={`/collectie/${c.slug}`} className="group relative block h-full overflow-hidden rounded-3xl bg-surface" data-id="element-133" data-mp="3djeayq9v3iur">
                <img src={t.image} alt="" className={`absolute inset-0 h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.04] ${t.position ?? ''}`} data-id="element-134" data-mp="38kl25b5isg0x" />
                <span className="absolute inset-x-3 bottom-3 flex items-center justify-between gap-3 rounded-2xl bg-white/95 px-4 py-3 backdrop-blur lg:inset-x-4 lg:bottom-4" data-id="element-135" data-mp="2ywpg51qk1tup">
                  <span data-id="element-136" data-mp="2kyr6g9n6illj">
                    <span className="block text-base font-semibold tracking-tight text-ink lg:text-lg" data-id="element-137" data-mp="2oyjgkqs80zt0">{c.title}</span>
                    <span className="block text-xs text-muted" data-id="element-138" data-mp="3cnlw9t3aoikv">{productsForCollection(c).length} producten</span>
                  </span>
                  <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-ink text-white transition-colors duration-150 group-hover:bg-pink" data-id="element-139" data-mp="3hmp1bdj9yosu">
                    <ArrowUpRightIcon className="h-4 w-4" data-id="element-140" data-mp="37wvns6zknzly" />
                  </span>
                </span>
              </Link>
            </li>;
      })}
      </ul>
    </section>;
}